export enum ValidateStatus {
  None,
  Valid,
  Invalid,
}

export interface FieldPayload {
  name: string;
  values: string[];
  otherValue?: string;
  isValid: ValidateStatus;
  displayedOptions?: string;
}
